// Thẻ «thiết bị tin cậy» (api/src/services/loginLockout.js) — máy chủ cấp sau mỗi lần đăng nhập THÀNH CÔNG, máy này
// gửi lại ở lần đăng nhập sau. Nhờ nó, kẻ dò mật khẩu từ máy lạ khoá được «mọi máy lạ» (10 lần sai / 15 phút) nhưng
// KHÔNG khoá được máy quen của chủ tài khoản.
//
// Lưu theo TỪNG email (một máy có thể đăng nhập nhiều tài khoản). localStorage có thể ném (chế độ riêng tư, chặn
// lưu trữ) ⇒ mọi lần đọc / ghi bọc try/catch: thiếu thẻ chỉ có nghĩa là lần đăng nhập đó đếm ở thùng «máy lạ».

const KEY = 'cnvwork-device-trust';
const MAX_ACCOUNTS = 10;

function readAll() {
  try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch { return {}; }
}

export function readDeviceTrust(email) {
  if (!email) return null;
  const v = readAll()[String(email).trim().toLowerCase()];
  return typeof v === 'string' ? v : null;
}

/** Ghi thẻ từ một phản hồi đăng nhập (`{ device_trust, user: { email } }`). */
export function rememberDeviceTrust(result) {
  const token = result?.device_trust;
  const email = result?.user?.email;
  if (!token || !email) return;
  try {
    const all = readAll();
    delete all[String(email).toLowerCase()];
    const next = { [String(email).toLowerCase()]: token, ...all };
    const trimmed = Object.fromEntries(Object.entries(next).slice(0, MAX_ACCOUNTS));
    localStorage.setItem(KEY, JSON.stringify(trimmed));
  } catch { /* best-effort */ }
}
